export default "/_next/static/images/b95d475278eff02c9e10dc19bb734693.png";